var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 -960 960 960","width":"size","height":_vm.size,"fill":"#none"}},[_c('path',{attrs:{"d":"m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }